export default "__VITE_ASSET__DGxlqoE0__"